import React from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector } from "react-redux";

const CityPage = () => {
  const { cityName } = useParams();
  const { data, headerIndexes } = useSelector((state) => state.data);

  if (!data || !headerIndexes) {
    return <div>Loading...</div>;
  }

  
  const decodedCityName = decodeURIComponent(cityName).toLowerCase();

  // Ensure required headers exist before processing
  const cityIndex = headerIndexes["City"];
  const taskNameIndex = headerIndexes["Task Name"];
  const typeIndex = headerIndexes["TYPE (labels)"];
  const productCodeIndex = headerIndexes["Product Code"]; // Only for private

  if (cityIndex === undefined || taskNameIndex === undefined || typeIndex === undefined) {
    return <div>Error: Required data is missing.</div>;
  }


  
  const privateProducts = new Set();
  const groupProducts = new Set();

  data.forEach((tour) => {
    const tourCity = tour[cityIndex]?.trim().toLowerCase();
    const tourType = tour[typeIndex]?.trim(); // Get booking type

    if (!tourCity || tourCity !== decodedCityName || !tourType) return;

    if (tourType === "Private" && productCodeIndex !== undefined) {
      // Extract Private Tour Product Code
      const privateCode = tour[productCodeIndex]?.trim();
      if (privateCode) privateProducts.add(privateCode);
    } else if (tourType === "Group") {
      
      const taskName = tour[taskNameIndex];
      if (typeof taskName === "string" && taskName.includes("-")) {
        const groupCode = taskName.split("-")[0]?.trim();
        if (groupCode) groupProducts.add(groupCode);
      }
    }
  });

  return (
    <div>
      <h2>Products in {decodeURIComponent(cityName)}</h2>

      <h3>Private Tours</h3>
      {privateProducts.size > 0 ? (
        <ul>
          {[...privateProducts].map((productCode, index) => (
            <li key={index}>
              <Link to={`/product/${encodeURIComponent(productCode)}`}>{productCode}</Link>
            </li>
          ))}
        </ul>
      ) : (
        <p>No private tours available.</p>
      )}

      <h3>Group Tours</h3>
      {groupProducts.size > 0 ? (
        <ul>
          {[...groupProducts].map((productCode, index) => (
            <li key={index}>
              <Link to={`/product/${encodeURIComponent(productCode)}`}>{productCode}</Link>
            </li>
          ))}
        </ul>
      ) : (
        <p>No group tours available.</p>
      )}
    </div>
  );
};

export default CityPage;
